// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1mWMg","signatureButtonsRight":"ModalSign_signatureButtonsRight__3nuzI"};